import {
  EarningsItemWithEntity,
  earningsItemWithEntitySchema,
} from '@api/api/earnings';
import {
  EconomicEventOutput,
  economicEventOutputSchema,
} from '@api/api/financial-events/economics-events';
import {
  KeyDevsObjectWithEntity,
  keyDevsObjectWithEntitySchema,
} from '@api/api/financial-events/key-developments-events';

export type CalendarEvents =
  | EarningsItemWithEntity
  | EconomicEventOutput
  | KeyDevsObjectWithEntity;

export const isEconomicEvent = (
  event: CalendarEvents
): event is EconomicEventOutput => {
  const { success } = economicEventOutputSchema.safeParse(event);
  return success;
};

export const isCompanyEvent = (
  event: CalendarEvents
): event is KeyDevsObjectWithEntity => {
  const { success } = keyDevsObjectWithEntitySchema.safeParse(event);
  return success;
};

export const isEarningsEvent = (
  event: CalendarEvents
): event is EarningsItemWithEntity => {
  const { success } = earningsItemWithEntitySchema.safeParse(event);
  return success;
};
